import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LazyAxios, catchError, getToken, handleRequest } from "../base";
import { url } from "../base/Variables";
import { removeToken } from "../base/CodeEasier";

const baseUrl = `${url}/api/v1/app`

const initialState = {
    user: null,
    cart_total_item: 0,
    app_loading: true,
    app_error: null,

    total_user: 467,
    total_shop: 10,
    total_product: 320,
    total_order: 589,
    avg_rating: 5,
    total_review: 100,
    my_review: null,
    other_review: null,
    get_app_analytics: false,

    top_selling_product: null,
    new_product: null,
    top_discount_product: null,
    top_category: null,
    category_options: ['all',
        'Maheshwari Bagh Print Sarees',
        'Maheshwari 75% Silk Sarees',
        'Maheshwari Zari-Jari Checks Sarees',
        'Maheshwari Tissue Silk Sarees',
        'Garbha Reshami Silk Sarees',
        'Maheshwari Dabu Print Sarees',
        'Maheshwari Buta-Buti & Buti Sarees',
        'Maheshwari Multi Shaded Sarees',

        'Maheshwari Multi Coloured Border Sarees',
        'Maheshwari Resham Border Sarees',
        'Ganga Jamuna Border Sarees',
        'Maheshwari Bada Chhota Border Sarees',
        'Maheshwari Small Border Sarees',
        'Maheshwari Zari-Jari Border Sarees',

        'Maheshwari Jaal Pallu Sarees',
        'Maheshwari Jute Pallu Sarees',
        'Maheshwari Zari-Jari Pallu Sarees',

        'Maheshwari Silk Dupattas',
        'Maheshwari Handblock Print Suits'
    ],

    states: [
        "Select State",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal"
    ]

}

const getUserInfo = createAsyncThunk('getUserInfo', async (_, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.get(`${baseUrl}/getUserInfo/`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})



const getAppAnalytics = createAsyncThunk('getAppAnalytics', async (_, { rejectWithValue }) => {
    try {
        const axios = await LazyAxios()
        const request = await axios.get(`${baseUrl}/getAppAnalytics/`)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})


const getTopCategory = createAsyncThunk('getTopCategory', async (_, { rejectWithValue }) => {
    try {
        const axios = await LazyAxios()
        const request = await axios.get(`${url}/api/v1/product/getTopCategory/`)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const appSlice = createSlice({
    name: 'appSlice',
    initialState: initialState,
    reducers: {
        appSliceDefault(state, action) {
            state.user = null
            state.cart_total_item = 0
        },
        // setting user to action.payload
        setUser(state, action) {
            state.user = action.payload
        },
        // set the suggested products
        setSuggestedProduct(state, action) {
            const type = action.payload.type
            if (type === 'top_selling') {
                state.top_selling_product = action.payload.data
            }
            else if (type === 'new_product') {
                state.new_product = action.payload.data
            }
            else if (type === 'top_discount') {
                state.top_discount_product = action.payload.data
            }
        },
        // inc or dec the cart total item
        changeCartTotalItem(state, action) {
            if (action.payload.type === 'inc') {
                state.cart_total_item += 1
            }
            else if (action.payload.type === 'dec' && state.cart_total_item >= 1) {
                state.cart_total_item -= 1
            }
            else if (action.payload.type === 'set0') {
                state.cart_total_item = 0
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserInfo.pending, (state) => {
                state.app_loading = true
            })
            .addCase(getUserInfo.fulfilled, (state, action) => {
                state.app_loading = false
                state.user = action.payload.user
                state.cart_total_item = action.payload.cart_total_item
            })
            .addCase(getUserInfo.rejected, (state, action) => {
                state.app_loading = false
                removeToken()
            }) // get the user info 

            .addCase(getAppAnalytics.fulfilled, (state, action) => {
                console.log(action.payload)
                state.avg_rating = action.payload.avg_rating
                state.total_order = action.payload.total_order
                state.total_product = action.payload.total_product
                state.total_review = action.payload.total_review
                state.total_shop = action.payload.total_shop
                state.total_user = action.payload.total_user
                state.get_app_analytics = true
            })


            .addCase(getTopCategory.fulfilled, (state, action) => {
                state.top_category = action.payload.data
                state.category_options = action.payload.data && action.payload.data.length > 0 && ['all', ...action.payload.data.map(item => item.name)]
            })


    }
})

export default appSlice;
export { getUserInfo, getAppAnalytics, getTopCategory };
export const { appSliceDefault, setUser, changeCartTotalItem, setSuggestedProduct } = appSlice.actions;
